import { useQuery } from '@tanstack/react-query'
import { WorkOrderResponse } from '../client'
import { getV1WorkOrdersByIdOptions } from '../client/@tanstack/react-query.gen'
import { ExtendedQueryOptions } from '../types'

export type WorkOrder = WorkOrderResponse
export type Signature = NonNullable<WorkOrderResponse['signatureReceive']>

export const useWorkOrder = (id: string, options?: ExtendedQueryOptions<WorkOrderResponse>) => {
  const query = useQuery({
    ...getV1WorkOrdersByIdOptions({
      path: {
        id,
      },
    }),
    ...options,
  })

  return query
}
